import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./resetpassword.css";

function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setPopup({ show: true, type: "error", message: "Passwords  do not match!" });
      return;
    }

    try {
      const res = await fetch("https://bodhimaram.onrender.com/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      const data = await res.json();

      if (res.ok) {
        setPopup({ show: true, type: "success", message: data.message });
      } else {
        setPopup({ show: true, type: "error", message: data.error });
      }
    } catch (err) {
      setPopup({ show: true, type: "error", message: "Server error! Please try again." });
    }
  };

  return (
    <div className="reset-container">
      <div className="logo">Saaragka</div>

      <div className="reset-box">
        <h2>Reset Your Password</h2>
        <form onSubmit={handleSubmit} className="reset-form">
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button type="submit">Reset Password</button>
        </form>
      </div>

      {/* Popup Modal */}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box ${popup.type}`}>
            <div className="popup-icon">
              {popup.type === "success" ? "✔" : "✖"}
            </div>
            <p>{popup.message}</p>
            <button
              onClick={() => {
                if (popup.type === "success") navigate("/");
                setPopup({ show: false, type: "", message: "" });
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ResetPassword;
